export default [
    {
        path: 'ria-gerenciamento-envio',
        component: () => import(
            /* webpackChunkName: 'integracao-ria-gerenciamento-envio' */
            '@/views/integracao/ria/gerenciamento-envio/Index'
        ),
        redirect: 'ria-gerenciamento-envio/index',
        children: [
            {
                name: 'integracao-ria-gerenciamento-envio-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'integracao-ria-gerenciamento-envio' */
                    '@/views/integracao/ria/gerenciamento-envio/List.vue'
                ),
            },
        ],
    },
]